import { render, staticRenderFns } from "./followResource.vue?vue&type=template&id=37a4c150&scoped=true&"
import script from "./followResource.vue?vue&type=script&lang=js&"
export * from "./followResource.vue?vue&type=script&lang=js&"
import style0 from "./followResource.vue?vue&type=style&index=0&id=37a4c150&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a4c150",
  null
  
)

export default component.exports